(() => {
  const pairIdProperty = '_subscription_pair_id';
  const pairRoleProperty = '_subscription_pair_role';
  let reconciling = false;

  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const reconcilePairs = async (providedCart) => {
    if (reconciling) return;
    reconciling = true;

    try {
      let cart = providedCart;
      if (!cart?.items) {
        const cartResponse = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) return;
        cart = await cartResponse.json();
      }

      const pairs = new Map();
      cart.items.forEach((item) => {
        const pairId = item.properties?.[pairIdProperty];
        const pairRole = item.properties?.[pairRoleProperty];
        if (!pairId || !pairRole) return;
        if (!pairs.has(pairId)) pairs.set(pairId, { main: [], subscription: [] });
        const pair = pairs.get(pairId);
        if (pairRole === 'main') pair.main.push(item);
        if (pairRole === 'subscription') pair.subscription.push(item);
      });

      const updates = {};
      pairs.forEach((pair) => {
        if (pair.main.length === 0) {
          pair.subscription.forEach((item) => { updates[item.key] = 0; });
        }
      });
      if (Object.keys(updates).length === 0) return;

      const response = await fetch(`${rootUrl()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: ['mini-cart'], sections_url: window.location.pathname })
      });
      const updatedCart = await response.json();
      if (!response.ok) return;

      if (window.location.pathname === `${rootUrl()}cart` || window.location.pathname === '/cart') {
        window.location.reload();
        return;
      }

      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: updatedCart, sections: updatedCart.sections, openMiniCart: true }
      }));
    } catch (error) {
      console.warn('Unable to reconcile subscription pair.', error);
    } finally {
      reconciling = false;
    }
  };

  window.addEventListener('cart:updated', (event) => reconcilePairs(event.detail?.cart));
  if (window.location.pathname === `${rootUrl()}cart` || window.location.pathname === '/cart') {
    document.addEventListener('DOMContentLoaded', () => reconcilePairs());
  }
})();
